var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "CustomerSupport",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-customer-support","viewBox":"0 0 518 518"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M518.6 270.8h-44.4c-1.4-9.6-5.4-26-16.1-40.4-.5-.6-11-14.2-27.5-20.2 13.1-8.4 21.8-23.1 21.8-39.8 0-26.1-21.2-47.3-47.3-47.3s-47.3 21.2-47.3 47.3c0 16.5 8.5 31 21.3 39.5-9.9 3.1-20.9 9-29.7 20.5-9.2-19.3-22.4-31.7-33.9-39.4-8.1-5.4-16.2-9-23-11.4 20.8-11.7 34.9-33.9 34.9-59.4 0-37.5-30.5-68.1-68.1-68.1-37.5 0-68.1 30.5-68.1 68.1 0 25.1 13.7 47.1 34 58.9-24.1 7.3-42.9 24.2-55.2 49.8-.2.4-.3.7-.5 1.1-8.7-11.2-19.6-17.1-29.4-20.1 12.8-8.5 21.3-23 21.3-39.5 0-26.1-21.2-47.3-47.3-47.3-26.1 0-47.3 21.2-47.3 47.3 0 16.7 8.7 31.5 21.9 39.9-17.2 6.1-26.1 17.9-27.7 20.2-10 12.5-14.2 30.2-15.8 40.3H0v14.4h31.2v170.4H487V285.2h31.5v-14.4zM405 137.6c18.1 0 32.9 14.8 32.9 32.9s-14.8 32.9-32.9 32.9-32.9-14.8-32.9-32.9 14.8-32.9 32.9-32.9zm-16 84.7c7.6-1.5 27-.8 32 .2 15 3 25.5 16.5 25.6 16.6 8.1 10.9 11.5 23.5 13 31.7h-99.2c-.9-8.6-2.5-16.4-4.5-23.5 8.4-16.9 22.5-22.9 33.1-25zm-183.3-102c0-29.6 24.1-53.7 53.7-53.7s53.7 24.1 53.7 53.7-24.2 53.7-53.8 53.7c-29.6 0-53.6-24.1-53.6-53.7zm43.5 69.2l.8-.1s4.8-.8 11.3-.8c3.8 0 7.5.3 10.9.8l.4.1c.2 0 17.7 2 35.5 13.9 21.7 14.6 34.4 37.3 37.9 67.4H172.1c1.3-8.3 4.3-21.9 10.9-35.6 13.8-28.7 36-44 66.2-45.7zm-135-51.9c18.1 0 32.9 14.8 32.9 32.9s-14.8 32.9-32.9 32.9-32.9-14.8-32.9-32.9 14.7-32.9 32.9-32.9zM72.5 239.3l.4-.6c.3-.5 8.4-12.3 25.6-16.3 4.4-1 23.7-1.7 31.8-.1 10.4 2 24.3 8 32.8 24.4-3.1 9.8-4.7 18.4-5.5 24.1H59.9c1.6-8.9 5.2-22.4 12.6-31.5zm400.1 201.9h-427V285.9h427v155.3z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/customer-support.svg